import React, { useState } from "react";
import Voucher from "./Voucher";
import {
    Gift
} from "lucide-react";
import { Pagination } from "antd";

const VoucherGrid = ({ vouchers = [], onAdd }) => {

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);

    const startIndex = (currentPage - 1) * pageSize;

    const paginatedMerchants = vouchers.slice(
        startIndex,
        startIndex + pageSize
    );

    const handlePageChange = (page, size) => {
        setCurrentPage(page);
        setPageSize(size);
    };
    
    if (!vouchers.length) {
        return (
        <div className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border p-12">
            <div className="text-center muted-text">
                <Gift className="w-12 h-12 mx-auto opacity-50" />
                <p>No vouchers found matching your criteria.</p>
            </div>
        </div>
        );
    }

    return (<>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {paginatedMerchants.map((voucher) => (
            <Voucher 
                key={voucher.merchant_id} 
                voucherData={voucher}
            />
        ))}
        </div>
        <div className="flex justify-center mt-8">
            <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={vouchers.length}
            onChange={handlePageChange}
            showSizeChanger
            pageSizeOptions={[20, 30, 40, 50, 80, 100]}
            />
        </div>
      </>
    );
};

export default VoucherGrid;
